import { defineAsyncComponent } from 'vue';
const DOCTYPES_BY_TEMPLATE = {
	ContentPage: defineAsyncComponent(
		() => import('~/doctypes/ContentPage.vue')
	),
	mbaArticlePage: defineAsyncComponent(
		() => import('~/doctypes/ArticlePage.vue')
	),
	mbaNewsPage: defineAsyncComponent(() => import('~/doctypes/NewsPage.vue')),
	mbaFilePage: defineAsyncComponent(() => import('~/doctypes/FilePage.vue')),
	MbaSpecialPageSetPassword: defineAsyncComponent(
		() => import('~/doctypes/SetPasswordPage.vue')
	),
	MbaSpecialPageResetPassword: defineAsyncComponent(
		() => import('~/doctypes/ResetPasswordPage.vue')
	),
	mbaKnowledgeContainer: defineAsyncComponent(
		() => import('~/doctypes/KnowledgeContainer.vue')
	),
	mbaNewsList: defineAsyncComponent(() => import('~/doctypes/NewsList.vue')),
	mbaFrontPage: defineAsyncComponent(
		() => import('~/doctypes/Frontpage.vue')
	),
	mbaAboutPage: defineAsyncComponent(
		() => import('~/doctypes/AboutPage.vue')
	),
	mbaTreatmentGuide: defineAsyncComponent(
		() => import('~/doctypes/TreatmentGuide.vue')
	),
	MbaSpecialPageProjects: defineAsyncComponent(
		() => import('~/doctypes/CaseList.vue')
	),
	MbaSpecialPageAddTaskToProject: defineAsyncComponent(
		() => import('~/doctypes/AddToCase.vue')
	),
	MbaSpecialPageCreateProject: defineAsyncComponent(
		() => import('~/doctypes/CreateProject.vue')
	),
	MbaSpecialPageAccess: defineAsyncComponent(
		() => import('~/doctypes/AccessPage.vue')
	),
	MbaSpecialPageFindByTreatmentGuidelineCode: defineAsyncComponent(
		() => import('~/doctypes/FindByCode.vue')
	),
	MbaSpecialPageTasks: defineAsyncComponent(
		() => import('~/doctypes/TasksPage.vue')
	),
	MbaSpecialPageSupplier: defineAsyncComponent(
		() => import('~/doctypes/SupplierPage.vue')
	),
	MbaSpecialPageProducts: defineAsyncComponent(
		() => import('~/doctypes/ProductsList.vue')
	),
	MbaSpecialPageProduct: defineAsyncComponent(
		() => import('~/doctypes/ProductPage.vue')
	),
	sharedLoginPage: defineAsyncComponent(
		() => import('~/../frontend-shared/doctypes/LoginPage.vue')
	),
	sharedSubscriptionPage: defineAsyncComponent(
		() => import('~/../frontend-shared/doctypes/SubscriptionPage.vue')
	),
	sharedCreateUserPage: defineAsyncComponent(
		() => import('~/../frontend-shared/doctypes/CreateLoginPage.vue')
	)
};

export const getDoctypeFromTemplate = (template) => `${template}`;

// format that allows local registration via `components`
export default Object.entries(DOCTYPES_BY_TEMPLATE).reduce(
	(acc, [template, doctype]) => ({
		...acc,

		[getDoctypeFromTemplate(template)]: doctype,
	}),
	{}
);
